import { useQuery } from '@tanstack/react-query'
import { api } from './api'

/**
 * Server-side feature flags, served by the public /api/auth/methods. A flag that
 * is off means the endpoints behind it answer 404, so the UI must hide every
 * trace of the feature — links, nav items and the routes themselves.
 */
export function useFeatureFlags() {
  const { data, isLoading } = useQuery({
    queryKey: ['auth-methods'],
    queryFn: api.authMethods,
    staleTime: 5 * 60 * 1000,
  })
  return { accessRequests: data?.accessRequests ?? false, mailpit: data?.mailpit ?? false, isLoading }
}
